// src/componentes/PrivateRoute.jsx
import { Navigate } from "react-router-dom";
import { useAppContext } from "../../src/pages/context/AppContext.jsx";

function PrivateRoute({ children }) {

  const { accessKey } = useAppContext(); // Acessa os dados do contexto
  const isAuthenticated = !!accessKey; // ou outra verificação
  return isAuthenticated ? children : <Navigate to="/" replace />;
}

export default PrivateRoute;
